<template>
  <div class="date-picker-range-container">
    <div class="date-picker-range-label">{{ label }}</div>
    <div class="picker-content">
      <EditorDatePicker
        :value="startDate"
        v-bind="$attrs"
        v-on="$listeners"
        style="flex: 1"
        :placeholder="startPlaceholder"
        @change="startDateChange"
      />
      <div class="date-picker-range-symbol"></div>
      <EditorDatePicker
        :value="endDate"
        v-bind="$attrs"
        v-on="$listeners"
        style="flex: 1"
        :placeholder="endPlaceholder"
        :is-present="isPresent"
        :display-present="true"
        @change="endDateChange"
      />
    </div>
  </div>
</template>
<script>
import EditorDatePicker from "../EditorDatePicker/EditorDatePicker.vue";
export default {
  name: "EditorDatePickerRange",
  components: {
    EditorDatePicker,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    startPlaceholder: {
      type: String,
      default: "请选择开始日期",
    },
    endPlaceholder: {
      type: String,
      default: "请选择结束日期",
    },
    startDate: {
      type: [String, Date, Object],
      default: "",
    },
    endDate: {
      type: [String, Date, Object],
      default: "",
    },
    isPresent: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    startDateChange(value) {
      this.$emit("startDateChange", value);
    },
    endDateChange(value, isPresent) {
      this.$emit("endDateChange", value, isPresent, this.itemData);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.date-picker-range-container {
  display: flex;
  flex-direction: column;
  .date-picker-range-label {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .picker-content {
    display: flex;
    align-items: center;
    .date-picker-range-symbol {
      width: 12px;
      height: 1px;
      background-color: $date-picker-symbol-color;
      margin: 0 6px;
    }
  }
}
</style>
